import { Heading, Paragraph, Label } from '@/components/atoms';
import { RadioGroup, RadioGroupItem } from '@/components/atoms';
import { useState } from 'react';
import { TwoFactorDialogWrapper } from './two-factor-dialog-wrapper';

interface TwoFactorMethodSelectionProps {
  isOpen: boolean;
  onClose: () => void;
  onMethodSelect: (method: 'totp' | 'email' | 'whatsapp') => void;
}

export const TwoFactorMethodSelection = ({
  isOpen,
  onClose,
  onMethodSelect,
}: TwoFactorMethodSelectionProps) => {
  const [selectedMethod, setSelectedMethod] = useState<
    'totp' | 'email' | 'whatsapp'
  >('email');

  const handleContinue = () => {
    if (selectedMethod) {
      onMethodSelect(selectedMethod);
    }
  };

  return (
    <TwoFactorDialogWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Set up Two-Factor Authentication"
      description="Choose your 2FA method"
      onContinue={handleContinue}
      continueDisabled={!selectedMethod}
    >
      <RadioGroup
        value={selectedMethod}
        onValueChange={(value) =>
          setSelectedMethod(value as 'totp' | 'email' | 'whatsapp')
        }
        className="flex flex-col gap-4"
      >
        {/* Authenticator App Option */}
        <div className="flex items-start gap-4 px-3 py-4 border border-gray-200 rounded-xl bg-white hover:border-primary/50 transition-all">
          <RadioGroupItem value="totp" id="totp" />
          <Label
            htmlFor="totp"
            className="flex flex-col items-start cursor-pointer"
          >
            <div className="flex max-sm:flex-col items-center gap-2 justify-between mb-0">
              <Heading size="sm" className="text-primary font-semibold">
                Authenticator app
              </Heading>
              <span className="text-xs bg-green-100 text-green-700 px-3 py-1 rounded-full font-medium">
                Recommended
              </span>
            </div>
            <Paragraph size="sm" className="text-gray-600">
              Use an app like Google Authenticator or authy. This is most secure
              option.
            </Paragraph>
          </Label>
        </div>

        {/* Email OTP Option */}
        <div className="flex items-start gap-4 px-3 py-4 border border-gray-200 rounded-xl bg-white hover:border-primary/50 transition-all">
          <RadioGroupItem value="email" id="email" />
          <Label
            htmlFor="email"
            className="flex flex-col items-start cursor-pointer"
          >
            <Heading size="sm" className="text-primary font-semibold mb-0">
              Email OTP
            </Heading>
            <Paragraph size="sm" className="text-gray-600">
              Receive codes via email. Backup option, less secure if email is
              compromised
            </Paragraph>
          </Label>
        </div>

        {/* SMS Text Message Option */}
        <div className="flex items-start gap-4 px-3 py-4 border border-gray-200 rounded-xl bg-white hover:border-primary/50 transition-all">
          <RadioGroupItem value="whatsapp" id="whatsapp" />
          <Label
            htmlFor="whatsapp"
            className="flex flex-col items-start cursor-pointer"
          >
            <Heading size="sm" className="text-primary font-semibold mb-0">
              WhatsApp
            </Heading>
            <Paragraph size="sm" className="text-gray-600">
              Receive codes via WhatsApp. Convenient and more secure than SMS
            </Paragraph>
          </Label>
        </div>
      </RadioGroup>
    </TwoFactorDialogWrapper>
  );
};
